import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-ready-product-parent',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './ready-product-parent.component.html',
  styleUrl: './ready-product-parent.component.css'
})
export class ReadyProductParentComponent {}
